import { IRoom } from '../models/Room'
import theme from '../theme/theme'
import { IDimensions } from '../utils/Canvas'
import drawRoom from './drawRoom'
import { IntegrationSync } from '../reducers/airbnb'

export default (
  ctx: CanvasRenderingContext2D,
  constants: IDimensions,
  cHeight: number,
  rooms: IRoom[],
  startRoomIdx: number,
  sync: IntegrationSync,
) => {
  ctx.textAlign = 'left'
  let count = 0
  ctx.fillStyle = theme.colors.calendar.gridBorder
  ctx.fillRect(
    constants.ROOM_WIDTH - constants.GRID_BORDER_WIDTH,
    0,
    constants.GRID_BORDER_WIDTH,
    cHeight,
  )
  for (
    let basei = 0;
    basei <= cHeight + constants.GRID_HEIGHT;
    basei += constants.GRID_HEIGHT
  ) {
    const room = rooms[startRoomIdx + count]
    if (!room) break
    const i = basei
    drawRoom(ctx, constants, i, room, sync)
    count++
  }
}
